"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSortableColumn = exports.useIsColumnPinned = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _useSyncElementDimension = _interopRequireDefault(require("../common/useSyncElementDimension"));
var _HBTableCheckbox = _interopRequireDefault(require("./HBTableCheckbox"));
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _ArrowLineDown = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowLineDown12"));
var _ArrowLineUp = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowLineUp12"));
var _HBInfoIcon = _interopRequireDefault(require("../HBInfoIcon/HBInfoIcon"));
var _mixins = require("../../styles/mixins");
var _sortable = require("@dnd-kit/sortable");
var _HBTable = require("./HBTable.styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var useIsColumnPinned = exports.useIsColumnPinned = function useIsColumnPinned(table, column) {
  var _table$options$meta = table.options.meta,
    isFirstColumnPinned = _table$options$meta.isFirstColumnPinned,
    isLastColumnPinned = _table$options$meta.isLastColumnPinned;
  return isFirstColumnPinned && column.getIndex() === 0 || isLastColumnPinned && column.getIndex() === table.getAllColumns().length - 1;
};
var useSortableColumn = exports.useSortableColumn = function useSortableColumn(table, column) {
  var columnIndex = column.getIndex();
  var isPinnedColumn = useIsColumnPinned(table, column);
  var dropIndex = isPinnedColumn ? !columnIndex ? 1 : columnIndex - 1 : columnIndex;
  return (0, _sortable.useSortable)({
    id: column.id,
    disabled: isPinnedColumn,
    data: {
      overIndex: dropIndex
    }
  });
};
function HBTableColumnHeader(_ref) {
  var column = _ref.column,
    tdEl = _ref.tdEl,
    table = _ref.table;
  var _useSyncElementDimens = (0, _useSyncElementDimension["default"])({
      sourceEl: tdEl,
      dimension: 'width',
      strategy: 'max'
    }),
    setTargetEl = _useSyncElementDimens.setTargetEl;
  var original = column.columnDef.meta.original;
  var testIdPrefix = table.options.meta.testIdPrefix;
  var isPinnedColumn = useIsColumnPinned(table, column);
  var _useSortableColumn = useSortableColumn(table, column),
    attributes = _useSortableColumn.attributes,
    listeners = _useSortableColumn.listeners,
    setNodeRef = _useSortableColumn.setNodeRef,
    transform = _useSortableColumn.transform,
    transition = _useSortableColumn.transition,
    isDragging = _useSortableColumn.isDragging;
  var handleSort = original.isSortable && function () {
    return table.setSorting(function (_ref2) {
      var prevSort = _ref2[0];
      return [{
        id: original.id,
        desc: prevSort.id === original.id ? !prevSort.desc : prevSort.desc
      }];
    });
  };
  var sorting = table.getState().sorting[0];
  var isSorted = sorting.id === original.id;
  var arrowIcon = sorting.desc ? _ArrowLineDown["default"] : _ArrowLineUp["default"];
  return /*#__PURE__*/_react["default"].createElement(TH, (0, _extends2["default"])({}, attributes, listeners, {
    $width: original.width,
    $isPinnedColumn: isPinnedColumn,
    $isDragging: isDragging,
    $isSortable: original.isSortable,
    $transition: transition,
    ref: original.width === 'fit' ? function (ref) {
      setTargetEl(ref);
      setNodeRef(ref);
    } : setNodeRef,
    style: {
      transform: (0, _HBTable.getColumnTransform)(transform, isPinnedColumn) // Transform changes rapidly and causes styled components performance issues
    },
    "data-testid": "".concat(testIdPrefix, "-").concat(original.title, "-header"),
    "aria-sort": !isSorted ? 'none' : sorting.desc ? 'descending' : 'ascending',
    role: "columnheader",
    tabIndex: -1
  }), /*#__PURE__*/_react["default"].createElement(_HBTable.DraggingShadow, {
    $isDragging: isDragging
  }), /*#__PURE__*/_react["default"].createElement(Container, {
    $isSorted: isSorted,
    insetFocusState: true
  }, /*#__PURE__*/_react["default"].createElement(Checkbox, {
    table: table,
    column: column
  }), original.prefix && /*#__PURE__*/_react["default"].createElement(PrefixContainer, null, original.prefix), original.title && /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    align: "left",
    type: "caption12",
    color: "textSecondary",
    transform: "capitalize"
  }, original.title), original.tooltip && /*#__PURE__*/_react["default"].createElement(_HBInfoIcon["default"], {
    tooltip: original.tooltip
  }), original.isSortable && /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    onClick: handleSort,
    className: arrowClassNme,
    size: 'xxs',
    label: 'sort-button',
    buttonTheme: 'subtle-invisible',
    testId: "".concat(testIdPrefix, "-sort-icon-button"),
    icon: arrowIcon
  })));
}
var _default = exports["default"] = HBTableColumnHeader;
function Checkbox(_ref3) {
  var _table$options$meta$b;
  var table = _ref3.table,
    column = _ref3.column;
  if (column.getIndex() !== 0 || table.options.meta.isInitialLoading || !((_table$options$meta$b = table.options.meta.bulkActions) !== null && _table$options$meta$b !== void 0 && _table$options$meta$b.length)) {
    return null;
  }
  var _table$getState = table.getState(),
    rowSelection = _table$getState.rowSelection;
  var isSomeRowsSelected = table.getRowModel().rows.some(function (row) {
    return row.id in rowSelection;
  });
  var isAllRowsSelected = rowSelection.all ? !isSomeRowsSelected : table.getIsAllRowsSelected();
  return /*#__PURE__*/_react["default"].createElement(_HBTableCheckbox["default"], {
    margin: "0 16px 0 0",
    checked: isAllRowsSelected,
    indeterminate: isSomeRowsSelected,
    testIdName: "header",
    onChange: function onChange(e) {
      table.toggleAllRowsSelected(rowSelection.all ? !e.target.checked : e.target.checked);
    }
  });
}
// -------------------------- Styles -------------------------- //

var TH = _styledComponents["default"].th.withConfig({
  displayName: "HBTableColumnHeader__TH",
  componentId: "sc-qwmgp9-0"
})(["&&{padding:0;", " background-color:", ";cursor:", ";", ";}"], _HBTable.draggingContainerStyles, function (_ref4) {
  var $isDragging = _ref4.$isDragging;
  return $isDragging ? _colors["default"].neutral200 : _colors["default"].neutral100;
}, function (_ref5) {
  var $isDragging = _ref5.$isDragging,
    $isPinnedColumn = _ref5.$isPinnedColumn;
  return $isDragging ? 'grabbing' : !$isPinnedColumn ? 'grab' : 'default';
}, function (_ref6) {
  var $width = _ref6.$width;
  return $width === 'fit' ? (0, _styledComponents.css)(["width:0;"]) : (0, _styledComponents.css)(["max-width:", "px;min-width:", "px;"], $width, $width);
});
var arrowClassNme = 'sort-arrow';
var Container = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBTableColumnHeader__Container",
  componentId: "sc-qwmgp9-1"
})(["padding:12px 16px;display:flex;align-items:center;gap:8px;white-space:nowrap;.", "{display:flex;opacity:", ";}", ",&:hover,&:focus-visible{.", "{opacity:1;}}"], arrowClassNme, function (_ref7) {
  var $isSorted = _ref7.$isSorted;
  return $isSorted ? 1 : 0;
}, _mixins.directHoverSelector, arrowClassNme);
var PrefixContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTableColumnHeader__PrefixContainer",
  componentId: "sc-qwmgp9-2"
})(["th:last-child &{margin-left:auto;}"]);
//# sourceMappingURL=HBTableColumnHeader.js.map